import { useMemo } from 'react'

const useIsMobile = () => {
  const isMobile = useMemo(() => {
    if (typeof window !== 'undefined') {
      const userAgent =
        typeof window.navigator === 'undefined'
          ? ''
          : window.navigator.userAgent.toLowerCase()
      const mobileKeywords = [
        'android',
        'iphone',
        'ipad',
        'ipod',
        'blackberry',
        'windows phone',
        'mobi',
        'opera mini'
      ]
      return mobileKeywords.some((keyword) => userAgent.includes(keyword))
    }
  }, [])

  return isMobile
}

export default useIsMobile
